import styled from 'styled-components';

import { Col } from '@notino/react-styleguide-v20';

import { PaymentSkeleton } from '@sharedComponents/Skeletons';

export const StyledPaymentListSkeleton = styled(Col)`
  margin-top: 3rem;
  padding-bottom: 3rem;
`;

export const StyledPaymentSkeleton = styled(PaymentSkeleton)`
  padding-bottom: 2rem;
`;
